import { LoadingOutlined } from '@ant-design/icons'
import { Upload } from 'antd'
import clsx from 'clsx'

import { ACCEPTED_UPLOAD_FILE_EXTENSIONS } from '../../libs/constants'
import CustomButton from '../CustomButton'
import { UploadIcon } from '../Icons'
import styles from './B2becUpload.module.scss'

interface B2becUploadProps {
  isUploading?: boolean
  customRequest?: (options: { file: File }) => void
  text?: string
  buttonClass?: string
}

const B2becUpload = ({
  isUploading = false,
  customRequest,
  text,
  buttonClass,
}: B2becUploadProps) => {
  const uploadButton = (
    <div className={styles.uploadBlock}>
      <CustomButton
        className={clsx(styles.customButton, buttonClass)}
        disabled={isUploading}
      >
        {isUploading ? <LoadingOutlined /> : <UploadIcon />}
        {text}
      </CustomButton>
    </div>
  )

  return (
    <Upload
      accept={ACCEPTED_UPLOAD_FILE_EXTENSIONS}
      customRequest={customRequest}
      disabled={isUploading}
      showUploadList={false}
    >
      {uploadButton}
    </Upload>
  )
}

export default B2becUpload
